import { useEffect } from 'react';

/**
 * Экран на всю ширину окна вместо колонки телефона (см. `html.full-width` в
 * `app/styles/index.css`). Для экранов веб-версии, у которых есть своя
 * раскладка под ноутбук: экран входа, `/login` и десктопный каркас
 * приложения (`DesktopShell`).
 */
export function useFullWidthPage(enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    const root = document.documentElement;
    root.classList.add('full-width');
    return () => root.classList.remove('full-width');
  }, [enabled]);
}
